define('modules/accounts/status/products/mdirector/view',['require','exports','module','views/BaseView','jquery','underscore','app','env','helpers/viewHelpers','views/ProgressBarView','./balance/view','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView");
  var $ = require("jquery");
  var _ = require("underscore");
  var app = require("app");
  var Config = require("env");
  var viewHelpers = require("helpers/viewHelpers");
  var ProgressBarView = require("views/ProgressBarView");
  var BalanceView = require("./balance/view");

  var showBalance = function (groupId) {
    return _.contains(Config.showBalanceArray, groupId);
  };

  var View = BaseView.extend({
    template: require("ldsh!./template"),
    events: {
      "change #numSMSByCountry": "countrySelected",
    },

    initialize: function () {
      if (this.model) {
        this.listenTo(this.model, "sync request error", this.render);
      }
    },

    beforeRender: function () {
      this.insertView(
        "#companies-progress-bar",
        new ProgressBarView({
          title: "ACCOUNTS.STATUS.COMPANIES_PROGRESS_BAR",
          num: this.group.getNumCompanies("mdirector"),
          max: this.group.getMaxCompanies("mdirector"),
        })
      );
      this.insertView(
        "#users-progress-bar",
        new ProgressBarView({
          title: "ACCOUNTS.STATUS.USERS_PROGRESS_BAR",
          num: this.group.getNumUsers("mdirector"),
          max: this.group.getMaxUsers("mdirector"),
        })
      );
      this.insertView(
        "#contacts-progress-bar",
        new ProgressBarView({
          title: "ACCOUNTS.STATUS.CONTACTS_PROGRESS_BAR",
          num: this.model.get("numContacts"),
          max: this.model.get("maxContacts"),
        })
      );
      if (showBalance(this.group.get("id"))) {
        this.insertView(
          "#balanceContainer",
          new BalanceView({
            model: this.model,
            group: this.group,
          })
        );
      }
    },

    clickAwayForCloseSelect2: function () {
      $(document).on("click", function (e) {
        if (!$(e.target).is(".select2-drop")) {
          // Select2 related...
          $(
            ".select2-multiple, .select2-container-multi, .select2, .chzn-select, .select2-multi-checkboxes-container, .select2-offscreen"
          ).select2("close");
        }
      });
    },

    afterRender: function () {
      $(".ayuda-context").popover();
      $("#numSMSByCountry").select2();
      this.clickAwayForCloseSelect2();

      if (this.model.get("countryId")) {
        $("#numSMSByCountry").select2("val", this.model.get("countryId"));
        this._showNumSMS("#numSMSByCountry");
      }
      app.i18n(this.el);
    },
    serialize: function () {
      var balance = this.model.get("balance");
      var templateParams = {
        group: this.group,
        model: this.model,
        servicePlan: this.group.getService("mdirector").type,
        mdirectorSummaryUrl:
          Config.mdirectorUrl +
          "/private?redirect=deliveryreport" +
          Config.getCompanyIdForUrl("&"),
        mdirectorMyRechargesUrl:
          Config.mdirectorUrl +
          "/private?redirect=rechargeshistoric" +
          Config.getCompanyIdForUrl("&"),
        paymentsUrl:
          Config.paymentsUrl + "account/products" + Config.getCompanyIdForUrl(),
        billingDataUrl:
          Config.paymentsUrl + "account/my-rate" + Config.getCompanyIdForUrl(),
        dailyEmailsAvailable: balance && balance.numOfEmailsPerDay,
        dailyEmailsRemaining: balance && balance.numOfEmailsPerDayLeft,
        dailySmsCreditsAvailable: balance && balance.numOfSmsCreditsPerDay,
        dailySmsCreditsRemaining: balance && balance.numOfSmsCreditsPerDayLeft,
        excessLimitIsOver: this.checkExcessLimitIsOver(
          balance && balance.canExceedEmailLimit,
          balance && balance.numEmails,
          balance && balance.numOfEmailsPerMonth
        ),
        shouldShowLinksToMD: this.shouldShowLinksToMD(),
      };

      return templateParams;
    },
    shouldShowLinksToMD: function () {
      var accounts = this.model.get("accounts");
      return (
        Config.companyId &&
        accounts &&
        _.find(accounts, function (account) {
          return account.empid === Config.companyId;
        })
      );
    },
    checkExcessLimitIsOver: function (canExceedEmailLimit, left, max) {
      return canExceedEmailLimit && left <= (max * 20) / 100;
    },

    countrySelected: function (e) {
      this._showNumSMS(e.currentTarget);
    },

    _showNumSMS: function (el) {
      var numSMS = $(el).find(":selected").attr("data-sms");
      $("#numSms").html(viewHelpers.formatNumber(numSMS));
    },
  });

  module.exports = View;
});

